import { BotProvider, LineBotProviderData } from "@/API";
import { CopyText } from "@/Components/CopyText";
import { Text } from "@mantine/core";

export function LineBotProviderDataCard(props: { botProvider: BotProvider }) {
    var botProviderData = props.botProvider.providerData as LineBotProviderData
    const webhookLink = window.origin + `/api/LineBot/webhook/${props.botProvider.id}`

    return <>
        <Text>ChannelId</Text>
        <CopyText text={botProviderData?.channelId ?? ""} />
        <Text>ChannelSecret</Text>
        <CopyText text={botProviderData?.channelSecret ?? ""} />
        <Text>ChannelAccessToken</Text>
        <CopyText text={botProviderData?.channelAccessToken ?? ""} />
        <Text>Webhook</Text>
        <CopyText text={webhookLink} />
    </>
}